import AccountCreationSuccess from ".";

export default function AccountCreationSuccessExamples() {
  return <AccountCreationSuccess onSubmit={() => console.log("onSubmit")} />;
}
